import { concat } from 'rxjs';
import LocationTally from './LocationTally';

class AwardsDataBuilder {
  results = [];
  
  awardNames = [];
  
  totals = null;

  constructor(data = {}, totals = {}, awardNames = [], buildObservableFn) {
    if (Object.entries(data)) {
      this.buildAwardData(data, buildObservableFn);
    }
    this.buildTotals(totals);
    this.awardNames = awardNames;
  }

  buildAwardData(data, buildObservableFn) {
    const observables = buildObservableFn(data);
    this.results = [];
    concat(...observables).subscribe((result) => this.results.push(result));
  }

  buildTotals(totals) {
    this.totals = LocationTally.fromObject(totals).setTally(totals);
  }

  get awards() {
    // if (this.awardNames?.length === 0) {
    //   this.awardNames = this.buildAwardNames();
    // }
    return this.awardNames;
  }

  buildAwardNames() {
    const awardNames = this.results.flatMap((result) => result.awardNames);
    return [...new Set(awardNames)];
  }
}

export default AwardsDataBuilder;
